import { jsx as _jsx } from "react/jsx-runtime";
import { format } from "date-fns";
import { parseURLDate } from "@travel/shared/utils";
export function DateText(_a) {
    var className = _a.className, _b = _a.date, date = _b === void 0 ? new Date() : _b, _c = _a.format, dateFormat = _c === void 0 ? "MMM dd, yyyy" : _c, inputFormat = _a.inputFormat;
    return (_jsx("time", { className: className, children: format(date instanceof Date
            ? date
            : inputFormat
                ? new Date()
                : parseURLDate(date), dateFormat) }));
}
